import { useQuery } from "@tanstack/react-query"; // Adjust the import according to your project structure
import { GET } from "../Controllers/ApiControllers";
import admin from "../Controllers/admin";

const getData = async (type) => {
  const url = type ? `get_configurations/group_name/${type}` : `get_configurations`;
  const res = await GET(admin ? admin : "", url);
  return res.data;
};

const useSettingsData = (type) => {
  const {
    isLoading: settingsLoading,
    data: settingsData,
    error: settingsError,
  } = useQuery({
    queryKey: ["settings", type],
    queryFn: async () => getData(type),
  });

  return { settingsData, settingsLoading, settingsError };
};

export default useSettingsData;
